import { ChapterTag, MaskedLine, Reveal } from "@/components/bits";

const CONFIGS = [
  { type: "Studio", area: "1042 – 1758 sqft", units: "11" },
  { type: "2 BHK", area: "1335 sqft", units: "176" },
  { type: "2.5 BHK", area: "1603 sqft", units: "188" },
  { type: "3 BHK", area: "1926 sqft", units: "340" },
  { type: "3.5 BHK", area: "2227 sqft", units: "140" },
];

export default function Residences() {
  return (
    <section id="residences" className="py-24 md:py-36" data-testid="residences-section">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <ChapterTag num="05" label="The Residences" />
        <h2 className="font-display mt-12 max-w-3xl text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
          <MaskedLine inView delay={0.05}>Space, light, and</MaskedLine>
          <MaskedLine inView delay={0.15}>
            <span className="italic text-[#064E3B]">the view that comes with it.</span>
          </MaskedLine>
        </h2>

        <div className="mt-20 grid grid-cols-1 gap-16 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal delay={0.15}>
              <div className="group overflow-hidden rounded-sm">
                <img
                  src="/images/living.jpg"
                  alt="Open-plan living room with warm wooden tones and large framed windows"
                  data-testid="living-image"
                  className="w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </div>
            </Reveal>
            <Reveal delay={0.3} className="mt-8 max-w-lg space-y-5 text-sm leading-relaxed text-[#57534E] md:text-base">
              <p>
                Living, dining, and kitchen areas are planned to be open and connected. Warm
                wooden tones, soft finishes, and large-framed windows bring in abundant daylight
                and frame views of the landscape corridors and water edges.
              </p>
              <p>
                Sloped terraces capture lake views as the towers step down towards the west —
                luxury here is experienced through space, light, and material.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={0.25}>
              <div className="grain relative overflow-hidden rounded-sm bg-[#022C22] p-8 md:p-12" data-testid="config-card">
                <div className="flex items-center justify-between">
                  <h3 className="text-xs font-semibold uppercase tracking-[0.3em] text-[#FAF9F6]/80">
                    Configurations &amp; Areas
                  </h3>
                  <span
                    className="rounded-full border border-[#A98B5F]/60 px-4 py-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-[#A98B5F]"
                    data-testid="price-on-request-badge"
                  >
                    Price on Request
                  </span>
                </div>
                <table className="mt-10 w-full" data-testid="config-table">
                  <thead>
                    <tr className="border-b border-[#F5F5F4]/15 text-left text-[10px] uppercase tracking-[0.26em] text-[#F5F5F4]/50">
                      <th className="pb-4 font-medium">Residence</th>
                      <th className="pb-4 font-medium">Area</th>
                      <th className="pb-4 text-right font-medium">Units</th>
                    </tr>
                  </thead>
                  <tbody>
                    {CONFIGS.map((c) => (
                      <tr
                        key={c.type}
                        data-testid={`config-row-${c.type.replace(/[\s.]/g, "-").toLowerCase()}`}
                        className="group border-b border-[#F5F5F4]/10 transition-colors duration-300 hover:bg-[#F5F5F4]/5"
                      >
                        <td className="font-display py-5 text-xl font-light text-[#FAF9F6] md:text-2xl">
                          {c.type}
                        </td>
                        <td className="py-5 text-sm text-[#F5F5F4]/70">{c.area}</td>
                        <td className="py-5 text-right text-sm text-[#F5F5F4]/70">{c.units}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <button
                  onClick={() => document.querySelector("#enquire")?.scrollIntoView({ behavior: "smooth" })}
                  data-testid="config-enquire-btn"
                  className="mt-10 w-full rounded-full bg-[#FAF9F6] py-4 text-xs font-semibold uppercase tracking-[0.24em] text-[#022C22] transition-transform duration-300 hover:scale-[1.02]"
                >
                  Request Price &amp; Floor Plans
                </button>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
